import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getDataFromPartnerAPI } from '../HandleAPICalls/actions';
import {
	setLoading,
	saveData,
} from './actions';
import {
	Table,Message,
	TableHeader,
	TableBody,
	TableFooter,
	TableRow,
	TableHeaderCell,
	TableCell,
	Checkbox,
	MenuItem,
	Icon,
	Menu,
	   Form ,
	
		ModalHeader,
		ModalDescription,
		ModalContent,
		ModalActions,
		Button,
		Header,
		Image,
		Modal,
	 
  } from 'semantic-ui-react';
import { Grid } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import './organization.css';
import OrganizationBrief from './OrganizationBrief';
import ActivateUser from './ActivateUser';
import { goBack } from 'react-router-redux';

// var checkedArray = [];
// var checkedArrayDeactivated = [];

export class ActiveUser extends Component {

	constructor(props) {
		super(props)
		this.state = {
			corporateList: [],
			activatedList: [],
			deactivatedList: [],
			active: true,
			checkedValue: [],
			checkedArray: [],
			checkedArrayDeactivated: [],
			filterText: '',
			filterType: 'email',
			searchActive: false,
			modelopen:false,
			corporateId: '',
			name: '',
			departmentName: '',
			email:"",
			error:false,
			ucmId:"",
			currentOffset:0,
		}
	}
fetchBpUsers = (offset = 0) => {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  const activeId = localStorage.getItem('activeItem');

  const limit = 50; // Still define how many items per fetch

  this.props.setLoading(true);

  this.props.getDataFromPartnerAPI(
    `/business-profile/${activeId}?limit=${limit}&offset=${offset}`,
    'GET',
    { Authorization: `Bearer ${token}` },
    (response) => {
      let newActivated = [], newDeactivated = [];

      response.forEach((item) => {
        if (item.status === true) newActivated.push(item);
        else newDeactivated.push(item);
      });

      this.props.saveData(response);

      this.setState((prevState) => ({
        activatedList:
          offset === 0
            ? newActivated
            : [...prevState.activatedList, ...newActivated],
        deactivatedList:
          offset === 0
            ? newDeactivated
            : [...prevState.deactivatedList, ...newDeactivated],
        isFetching: false,
      }));

      this.props.setLoading(false);
    },
    (err) => {
      this.props.setLoading(false);
      this.setState({ isFetching: false });
      toastr.error('ERROR', err);
      console.error(err);
    }
  );
};



 	Edit=(id,name,departmentName,email,ucmId)=>{
		this.setState({modelopen:true})
		this.setState({corporateId:id})
		this.setState({name:name})
		this.setState({departmentName:departmentName})
		this.setState({email:email})
		this.setState({ucmId:ucmId})
		console.log("Edit id",id)

	} 
fetchBpUsersList=()=>{
	this.props.setLoading(true);
		const ls = localStorage.getItem('data');
		const token = ls ? JSON.parse(ls).accessToken : '';
		const activeId = localStorage.getItem('activeItem');
		let tipArrayActivate = [];
		let tipArrayDeactivate = [];
		this.props.getDataFromPartnerAPI(
			`/business-profile/${activeId}`,
			'GET',
			{ 'Authorization': `Bearer ${token}` },
			response => {
				// this.setState({corporateList: response.data});
				this.props.saveData(response);
				response.map((item) => {
					if (item.status == true) {
						tipArrayActivate.push(item);
					} else {
						tipArrayDeactivate.push(item);
					}
				});
				this.props.setLoading(false);
				this.setState({ activatedList: tipArrayActivate })
				this.setState({ deactivatedList: tipArrayDeactivate })
			},
			err => {
				this.props.setLoading(false);
				toastr.error('ERROR', err);
				console.log(err);
			}
		);
		
}

	componentDidMount() {
		// this.props.setLoading(true);
		 this.fetchBpUsers();
		//this.fetchBpUsersList()
		
	}


	//  API for Deactivating selected users in the array 
	callDeactivateUser = () => {
		let usersList = this.state.checkedArray
		const activeId = localStorage.getItem('activeItem');
		this.props.getDataFromPartnerAPI(
			`/business-profile/${activeId}`,
			'DELETE',
			{ 'employeeIds': usersList },
			response => {
				const ls = localStorage.getItem('data');
				const token = ls ? JSON.parse(ls).accessToken : '';
				const activeId = localStorage.getItem('activeItem');
				let tipArrayActivate = [];
				let tipArrayDeactivate = [];
				this.props.getDataFromPartnerAPI(
					`/business-profile/${activeId}`,
					'GET',
					{ 'Authorization': `Bearer ${token}` },
					response => {
						// this.setState({corporateList: response.data});
						this.props.saveData(response);
						response.map((item) => {
							if (item.status == true) {
								tipArrayActivate.push(item);
							} else {
								tipArrayDeactivate.push(item);
							}
						});
						this.props.setLoading(false);
						this.setState({ activatedList: tipArrayActivate })
						this.setState({ deactivatedList: tipArrayDeactivate })
					},
					err => {
						this.props.setLoading(false);
						toastr.error('ERROR', err);
						console.log(err);
					}
				);
				this.setState({ checkedArray: [] });
	
			},
			err => {
				this.props.setLoading(false);
				toastr.error('ERROR', err);
				console.log(err);
			}
		);
	}

	// API for activating users selected from deactivated users list
	callActivateuser = () => {
		let usersList = this.state.checkedArrayDeactivated
		const activeId = localStorage.getItem('activeItem');
		this.props.getDataFromPartnerAPI(
			`/business-profile/${activeId}/activate`,
			'POST',
			{ 'employeeIds': usersList },
			response => {
				const ls = localStorage.getItem('data');
				const token = ls ? JSON.parse(ls).accessToken : '';
				const activeId = localStorage.getItem('activeItem');
				let tipArrayActivate = [];
				let tipArrayDeactivate = [];
				this.props.getDataFromPartnerAPI(
					`/business-profile/${activeId}`,
					'GET',
					{ 'Authorization': `Bearer ${token}` },
					response => {
						// this.setState({corporateList: response.data});
						this.props.saveData(response);
						response.map((item) => {
							if (item.status == true) {
								tipArrayActivate.push(item);
							} else {
								tipArrayDeactivate.push(item);
							}
						});
						this.props.setLoading(false);
						this.setState({ activatedList: tipArrayActivate })
						this.setState({ deactivatedList: tipArrayDeactivate })
					},
					err => {
						this.props.setLoading(false);
						toastr.error('ERROR', err);
						console.log(err);
					}
				);
				this.setState({ checkedArrayDeactivated: [] });
			},
			err => {
				this.props.setLoading(false);
				toastr.error('ERROR', err);
				console.log(err);
			}
		);
	}

	handleCheckActivated = (e) => {
		var checkboxes = document.getElementsByName('selectAll')
		for (var checkbox of checkboxes) {
			checkbox.checked = false;
		}
		const checked = e.target.checked;
		let value = e.target.value
		let name = e.target.name
		if (checked === true) {
			// checkedArray.push(value);
			this.setState({
				...this.state,
				// checkedArray: {...this.state.checkedArray, value},
				// checkedArray: [
				//     ...this.state.checkedArray,
				//     value,
				// ]
				checkedArray: [...new Set([...this.state.checkedArray, value])]

			})
		} else if (checked === false) {
			let arrayfiltered = this.state.checkedArray.filter(function (ele) {
				return ele != value;
			});
			this.setState({ checkedArray: arrayfiltered })
		}
	}

	handleCheckDeactivated = (e) => {
		var checkboxes = document.getElementsByName('selectAll')
		for (var checkbox of checkboxes) {
			checkbox.checked = false;
		}
		const checked = e.target.checked;
		let value = e.target.value
		let name = e.target.name
		if (checked === true) {
			this.setState({
				...this.state,
				checkedArrayDeactivated: [...new Set([...this.state.checkedArrayDeactivated, value])]

			})
		} else if (checked === false) {
			let arrayfiltered = this.state.checkedArrayDeactivated.filter(function (ele) {
				return ele != value;
			});
			this.setState({ checkedArrayDeactivated: arrayfiltered })
		}
	}

	selectAll = (e) => {
		let allArrayActivated = [];
		let allArrayDeactivated = [];
		if (this.state.active === true) {
			var checkboxes = document.getElementsByName('activeInput')
			for (var checkbox of checkboxes) {
				checkbox.checked = e.target.checked;
				if (checkbox.checked == true) {
					allArrayActivated.push(checkbox.value);
				} else if (checkbox.checked == false) {
					allArrayActivated = [];
				}
			}
			this.setState({
				...this.state,
				checkedArray: [...new Set([...allArrayActivated])]
			})
		} else {
			var checkboxesDeactivated = document.getElementsByName('deactivateInput')
			for (var checkbox of checkboxesDeactivated) {
				checkbox.checked = e.target.checked;
				if (checkbox.checked == true) {
					allArrayDeactivated.push(checkbox.value);
				} else if (checkbox.checked == false) {
					allArrayDeactivated = [];
				}
			}
			this.setState({
				...this.state,
				checkedArrayDeactivated: [...new Set([...allArrayDeactivated])]
			})
		}
	}

	toggleActive = () => {
		this.setState({ active: !this.state.active });
		this.setState({ checkedArray: [] });
		this.setState({ checkedArrayDeactivated: [] });
		var checkboxes = document.getElementsByName('selectAll')
		for (var checkbox of checkboxes) {
			checkbox.checked = false;
		}
	}

	handleSelectChange = (e) => {
		let value = e.target.value;
		this.setState({ filterType: value });
	}

	handleSearchChange = (e) => {
		let value = e.target.value
		let text = value
		let name = e.target.name
		this.setState({ filterText: text })
	}
	handleSearch = () => {
		this.setState({ searchActive: true });
		//console.log()
		let lowerCasedFilterText = this.state.filterText.toLowerCase();
		if (this.state.filterType == 'email') {
			let parameter = {
				emailId: lowerCasedFilterText
			}
			const ls = localStorage.getItem('data');
			const token = ls ? JSON.parse(ls).accessToken : '';
			const activeId = localStorage.getItem('activeItem');
			let tipArrayActivate = [];
			let tipArrayDeactivate = [];
			this.props.getDataFromPartnerAPI(
				`/business-profile/${activeId}?emailId=${lowerCasedFilterText}`,
				'GET',
				{ 'Authorization': `Bearer ${token}` },
				response => {
					console.log("activatedList response",response)
					this.props.saveData(response);
					response.map((item) => {
						
						if (item.status == true) {
							tipArrayActivate.push(item);
						} else {
							tipArrayDeactivate.push(item);
						}
					});
					this.props.setLoading(false);
					console.log("activatedList response tipArrayActivate",tipArrayActivate)
					this.setState({ activatedList: tipArrayActivate })
					this.setState({ deactivatedList: tipArrayDeactivate })
				},
				err => {
					this.props.setLoading(false);
					toastr.error('ERROR', err.message);
					console.log(err);
				}
			);
		} else if (this.state.filterType == 'name') {
			let parameter = {
				userName: lowerCasedFilterText
			}
			const ls = localStorage.getItem('data');
			const token = ls ? JSON.parse(ls).accessToken : '';
			const activeId = localStorage.getItem('activeItem');
			let tipArrayActivate = [];
			let tipArrayDeactivate = [];
			this.props.getDataFromPartnerAPI(
				`/business-profile/${activeId}?userName=${lowerCasedFilterText}`,
				'GET',
				{ 'Authorization': `Bearer ${token}` },
				response => {
					this.props.saveData(response);
					response.map((item) => {
						if (item.status == true) {
							tipArrayActivate.push(item);
						} else {
							tipArrayDeactivate.push(item);
						}
					});
					this.props.setLoading(false);
					this.setState({ activatedList: tipArrayActivate })
					this.setState({ deactivatedList: tipArrayDeactivate })
				},
				err => {
					this.props.setLoading(false);
					toastr.error('ERROR', err);
					console.log(err);
				}
			);
		} else if (this.state.filterType == 'orgid') {
			let parameter = {
				usersCorporateId: lowerCasedFilterText
			}
			const ls = localStorage.getItem('data');
			const token = ls ? JSON.parse(ls).accessToken : '';
			const activeId = localStorage.getItem('activeItem');
			let tipArrayActivate = [];
			let tipArrayDeactivate = [];
			this.props.getDataFromPartnerAPI(
				`/business-profile/${activeId}?usersCorporateId=${lowerCasedFilterText}`,
				'GET',
				{ 'Authorization': `Bearer ${token}` },
				response => {
					// this.setState({corporateList: response.data});
					this.props.saveData(response);
					response.map((item) => {
						if (item.status == true) {
							tipArrayActivate.push(item);
						} else {
							tipArrayDeactivate.push(item);
						}
					});
					this.props.setLoading(false);
					this.setState({ activatedList: tipArrayActivate })
					this.setState({ deactivatedList: tipArrayDeactivate })
				},
				err => {
					this.props.setLoading(false);
					toastr.error('ERROR', err);
					console.log(err);
				}
			);
		}

	}
	handleCancel = () => {
		this.setState({ modelopen: false });
	  };

handleScroll = (e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;
  const isBottom = scrollHeight - scrollTop - clientHeight < 10;

  if (isBottom && !this.state.isFetching) {
    const nextOffset = this.state.currentOffset + 1; // Increment offset by limit (5)
    this.setState(
      {
        isFetching: true,
        currentOffset: nextOffset,
      },
      () => {
        this.fetchBpUsers(this.state.currentOffset);
      }
    );
  }
};




	goBackFunc = () => {
		this.setState({ searchActive: false, filterText: "" });
		const ls = localStorage.getItem('data');
		const token = ls ? JSON.parse(ls).accessToken : '';
		const activeId = localStorage.getItem('activeItem');
		let tipArrayActivate = [];
		let tipArrayDeactivate = [];
		this.props.getDataFromPartnerAPI(
			`/business-profile/${activeId}`,
			'GET',
			{ 'Authorization': `Bearer ${token}` },
			response => {
				// this.setState({corporateList: response.data});
				this.props.saveData(response);
				response.map((item) => {
					if (item.status == true) {
						tipArrayActivate.push(item);
					} else {
						tipArrayDeactivate.push(item);
					}
				});
				this.props.setLoading(false);
				this.setState({ activatedList: tipArrayActivate })
				this.setState({ deactivatedList: tipArrayDeactivate })
			},
			err => {
				this.props.setLoading(false);
				toastr.error('ERROR', err);
				console.log('err------------------------h',err);
			}
		);
	}

	handleChange = (e, { name, value }) => {
		this.setState({ [name]: value });
	  };
	Approved=(e,ucmId)=>{
		console.log("ucmId------------->",ucmId)
		this.props.setLoading(true);
		const ls = localStorage.getItem('data');
		const token = ls ? JSON.parse(ls).accessToken : '';
		const activeId = localStorage.getItem('activeItem');
		//e.preventdefault()
		
		this.props.getDataFromPartnerAPI(
			`/business-profile/approve/${ucmId}`,
			'POST',
			undefined,
			response => {
				// this.setState({corporateList: response.data});
				console.log("Approved-------->",response)
				this.fetchBpUsersList()
		
				
			},
			err => {
				this.props.setLoading(false);
				toastr.error('ERROR', err);
				console.log(err);
			}
		);
	}
	handleSubmit = () => {
		// Add your form submission logic here
		console.log('Form submitted:', this.state);
		this.props.getDataFromPartnerAPI(
			`/business-profile/${this.state.ucmId}?corporateId=${this.state.corporateId}`,
			'PATCH',
			{
				"corporateId":this.state.corporateId,
	"userName":this.state.name,
	"email":this.state.email,
	"businessName":this.state.departmentName
			},
			response => {
				// this.setState({corporateList: response.data});
				console.log("Approved-------->",response)
				this.handleCancel()
				this.fetchBpUsersList()
		
				
			},
			err => {
				
				this.props.setLoading(false);
				toastr.error('ERROR', err);
				console.log(err);
				this.setState({error:true})
			})
	  };
	render() {

		let activatedList = this.state.activatedList;
		let deactivatedList = this.state.deactivatedList;
		let active = this.state.active;
	
		return (
			<div>
	  <Modal
        onClose={() => this.setState({ modelopen: false })}
        onOpen={() => this.setState({ modelopen: true })}
        open={this.state.modelopen}
		size='small'
		
        
      >
		
		<Modal.Content>
        <Form>
   {/*        <Form.Input
            label="Employee Id"
            placeholder="Enter Employee Id"
            name="employeeId"
            value={this.state.employeeId}
            onChange={this.handleChange}
          /> */}
          <Form.Input
            label="Name"
            placeholder="Enter Name"
            name="name"
            value={this.state.name}
            onChange={this.handleChange}
          />
          <Form.Input
            label="Department Name"
            placeholder="Enter Department Name"
            name="departmentName"
            value={this.state.departmentName}
            onChange={this.handleChange}
          />
             <div style={{display:"flex","justify-content":"flex-end",marginTop:"10%"}}> <Button color="green" onClick={this.handleSubmit}>Submit</Button>

			 <Button color="grey" onClick={this.handleCancel}>Cancel</Button>
			   </div> 
</Form>
      </Modal.Content>

       
      </Modal>
			<Grid padded style={{ marginTop: '0px', padding: '10vh' }}>
				<Helmet>
					<title>Select Your Organization</title>
				</Helmet>
				<Grid.Row>
					<Grid.Column width={11} textAlign="center" className='borderRight'>
						<div className='searchContainer'>
							<div className='statusToggle'>
								<div className='userStatusName'>{this.state.active ? 'Active' : 'Inactive'}</div>
								<div  onClick={() => this.toggleActive()} className={this.state.active ? 'toggleBackgroundActive' : 'toggleBackgroundInactive'}><div className='toggleCircle'></div></div>
							</div>
							<div className='inputWrapper'>
								<select name="filtertype" id="filtertype" onChange={(e) => this.handleSelectChange(e)}>
									<option selected value="email">Email</option>
									<option value="name">Name</option>
									<option value="orgid">Org ID</option>
								</select>
								<input type="text" value={this.state.filterText} onChange={(e) => this.handleSearchChange(e)} />
							</div>
							<div className='searchButton' onClick={() => this.handleSearch()}>Search</div>
						</div>
<Table celled>
  <Table.Header>
    <Table.Row>
      <Table.HeaderCell>
        <div className='checkboxDiv'>
          <input type='checkbox' name='selectAll' onChange={(e) => this.selectAll(e)} />
          <span> All</span>
        </div>
      </Table.HeaderCell>
      <Table.HeaderCell>Employee Id</Table.HeaderCell>
      <Table.HeaderCell>Name</Table.HeaderCell>
      <Table.HeaderCell>Email</Table.HeaderCell>
      <Table.HeaderCell>Department Name</Table.HeaderCell>
      <Table.HeaderCell>Edit</Table.HeaderCell>
      <Table.HeaderCell>Action</Table.HeaderCell>
    </Table.Row>
  </Table.Header>

  <Table.Body>
    {/* Scrollable Wrapper */}
    <tr>
      <td colSpan="7" style={{ padding: 0 }}>
        <div
          style={{ height: '500px', overflowY: 'auto' }}
          onScroll={(e) => this.handleScroll(e)}
        >
          <table style={{ width: '100%' }}>
            <tbody>
              {this.state.active ? (
                this.state.activatedList && this.state.activatedList.length > 0 ? (
                  this.state.activatedList.map((item) => (
                    <tr key={item.usersCorporateId}>
                      <td>
                        <div className='checkboxDiv'>
                          <input
                            type='checkbox'
                            id={item.usersCorporateId}
                            name='activeInput'
                            value={item.usersCorporateId}
                            onChange={(e) => this.handleCheckActivated(e)}
                          />
                        </div>
                      </td>
                      <td>{item.usersCorporateId}</td>
                      <td>{item.userName}</td>
                      <td>{item.emailId}</td>
                      <td>{item.businessName}</td>
                      <td
                        onClick={() =>
                          this.Edit(
                            item.corporateId,
                            item.userName,
                            item.businessName,
                            item.emailId,
                            item.ucmId
                          )
                        }
                        style={{ cursor: 'pointer' }}
                      >
                        Edit
                      </td>
                      <td>
                        {item.unlinkRequest && (
                          <button
                            onClick={(e) => this.Approved(e, item.ucmId)}
                            style={{
                              fontSize: '16px',
                              color: 'white',
                              background: '#4B1417',
                            }}
                          >
                            Approve Unlink
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">
                      <Message>No Active users found!</Message>
                    </td>
                  </tr>
                )
              ) : (
                this.state.deactivatedList && this.state.deactivatedList.length > 0 ? (
                  this.state.deactivatedList.map((item) => (
                    <tr key={item.usersCorporateId}>
                      <td>
                        <div className='checkboxDiv'>
                          <input
                            type='checkbox'
                            id={item.usersCorporateId}
                            name='deactivateInput'
                            value={item.usersCorporateId}
                            onChange={(e) => this.handleCheckDeactivated(e)}
                          />
                        </div>
                      </td>
                      <td>{item.usersCorporateId}</td>
                      <td>{item.userName}</td>
                      <td>{item.emailId}</td>
                      <td>{item.businessName}</td>
                      <td></td>
                      <td></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">
                      <Message>No Inactive users found!</Message>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </td>
    </tr>
  </Table.Body>
</Table>

				
					</Grid.Column>
					<Grid.Column width={4} textAlign="center">
						<div className='sideBarOrganization'>
							<OrganizationBrief />
							<div>
								{(this.state.checkedArray.length > 0 || this.state.checkedArrayDeactivated.length > 0) && (
									<div>
										<ActivateUser callAction={this.state.active ? () => this.callDeactivateUser() : () => this.callActivateuser()} apiCallButtonColor={this.state.active ? 'apiCallButtonDeactivate' : 'apiCallButtonActivate'} usersSelected={this.state.active ? this.state.checkedArray.length : this.state.checkedArrayDeactivated.length} buttonStatus={this.state.active ? 'Deactivate User' : 'Activate User'} />
									</div>
								)}
							</div>
						</div>
					</Grid.Column>
				</Grid.Row>
			</Grid></div>
		)
	}
}

function mapStateToProps({ activeUserList }) {
	return {
		activeUserList
	};
}

export default withRouter(
	connect(mapStateToProps, {
		getDataFromPartnerAPI,
		setLoading,
		saveData,
	})(ActiveUser)
);


// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/activeuser.jsx